
import apiCall from "../axios/apiCall";
const controller = "autenticacion";

export default {
  login: async (MSSOResponse) => {
    let response = { success: true, data: {} };
    if (!MSSOResponse.data.mail) MSSOResponse.data.mail = null;
    if (!MSSOResponse.data.accessToken) MSSOResponse.data.accessToken = null;

    const method = ``;

    const data = {
      correo_institucional: MSSOResponse.data.mail,
      token: MSSOResponse.data.accessToken
    }

    try {
      const apiResponse = await apiCall.postLogIn(controller, method, data);
      response.data.token = apiResponse?.data?.data?.token;
    } catch (error) {
      response = apiCall.handleCatch(error);
    }
    return response;
  }, 
  checkToken: async (token) => {
    let response = { success: true };
    const method = `checkToken`;
    try {
      const apiResponse = await apiCall.post(controller, method, { token: token });
      response.data = apiResponse?.data;
    } catch (error) {
      response = apiCall.handleCatch(error);
    }
    return response;
  },
}